export const statisticsAr = {
  "Versement": "المدفوعات",
  "Comptabilité": "المحاسبة",
  "Pourcentage": "نسبة مئوية",
  "soins": "رعاية",
  "Mode de paiement": "طريقة الدفع",
  "Total Restante": "المجموع المتبقي",
  "Statistiques Financières": "الإحصاءات المالية",
}